import { render, staticRenderFns } from "./integration-plate.vue?vue&type=template&id=3864d8cc&scoped=true&"
import script from "./integration-plate.vue?vue&type=script&lang=js&"
export * from "./integration-plate.vue?vue&type=script&lang=js&"
import style0 from "./integration-plate.vue?vue&type=style&index=0&id=3864d8cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3864d8cc",
  null
  
)

export default component.exports